document.addEventListener('DOMContentLoaded', function () {


    if (jQuery('.home_hero').length) {

        jQuery('.home_hero').mouseleave(function() {
            jQuery('.circle_holder, .circle_outer_holder').css('visibility', 'hidden');
        });

        jQuery('.home_hero').mouseenter(function() {
            jQuery('.circle_holder, .circle_outer_holder').css('visibility', 'visible');
        });
    }

    var partnersCarousel = document.querySelector('.partners_carousel');

    if (partnersCarousel) {

        var portfolioSwiper = new Swiper('.partners_carousel', {
            slidesPerView: 3,
            spaceBetween: 50,
            loop: true,
            breakpoints: {
                1024: {
                    slidesPerView: 5,
                    spaceBetween: 80,
                    speed: 1000,
                    navigation: {
                        nextEl: '.swipe-next',
                        prevEl: '.swipe-prev',
                    },
                },
            },
        });
        
    }

    var content_carousel_mob = document.querySelector('.content_carousel_mob');

    if (content_carousel_mob) {

        var contentSwiper = new Swiper('.content_carousel_mob', {
            slidesPerView: 1.3,
            spaceBetween: 22,
            loop: false,
            crossFade :true,
            lazy: {
                loadPrevNext: true,
                loadOnTransitionStart: true
            },
            preloadImages: false
        });

    }

    var fullscreen_carousel = document.querySelector('.fullscreen_carousel');

    if (fullscreen_carousel) {

        var fullscreen_carouselSwiper = new Swiper('.fullscreen_carousel', {
            slidesPerView: 1,
            pagination: {
                el: '.fullscreen_carousel .swiper-pagination',
                clickable: true,
            },
            effect:'fade',
            loop: false,
            crossFade: true,
            autoplay: {
                delay: 10000,
                disableOnInteraction: false
            }
        });

    }

    var fullscreen_slider = document.querySelector('.fullscreen_slider');

    if (fullscreen_slider) {

        var fullscreen_sliderSwiper = new Swiper('.fullscreen_slider', {
            slidesPerView: 1,
            pagination: {
                el: '.fullscreen_slider .swiper-pagination',
                clickable: true,
            },
            effect:'fade',
            loop: false,
        });

    }


    var circle_holder = document.querySelector('.circle_holder');

    if(circle_holder) {
        const parent = jQuery('.circle_holder').parent();

        parent.on('mousemove', function(e) {
            // Get the relative position within the parent container
            const parentOffset = jQuery(this).offset();
            const relX = e.pageX - parentOffset.left;
            const relY = e.pageY - parentOffset.top;

            // Position the circle_holder where the mouse is
            jQuery('.circle_holder').css({
                left: relX + 'px',
                top: relY + 'px'
            });
        });

        parent.on('mousemove', function(e) {
            // Get the relative position within the parent container
            const parentOffset = jQuery(this).offset();
            const relX = e.pageX - parentOffset.left;
            const relY = e.pageY - parentOffset.top;

            // Position the circle_holder where the mouse is
            jQuery('.circle_outer_holder').css({
                left: relX + 'px',
                top: relY + 'px'
            });
        });

    }



    var home_hero_carousel = document.querySelector('.home_hero_carousel');

    if (home_hero_carousel) {

        var home_hero_carouselSwiper = new Swiper('.home_hero_carousel', {
            slidesPerView: 1,
            pagination: {
                el: '.home_hero .swiper-pagination',
                clickable: true,
            },
            effect: 'fade',
            loop: false,
            crossFade: true,
            preloadImages: true,
            lazy: {
                enabled: true,
                loadPrevNext: false,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: false
            },
            autoplay: {
                delay: 10000,
                disableOnInteraction: false
            }
        });

    }

    jQuery(document).on('click', '.play_vid_pop', function(e) {

        e.preventDefault();

        // Get video ID from data attribute
        const videoId = jQuery(this).data('vid');

        // Create iframe HTML
        const iframeHtml = `
        <div class="video_popup">
            <div class="popup_overlay"></div>
            <div class="popup_content">
                <div class="close_popup">&times;</div>
                <iframe 
                    style="aspect-ratio: 16/9; min-width:70%;"
                    src="https://www.youtube.com/embed/${videoId}?autoplay=0" 
                    frameborder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                    allowfullscreen>
                </iframe>
            </div>
        </div>
    `;
        jQuery('body').append(iframeHtml);
    });

    jQuery(document).on('click', '.popup_overlay, .close_popup', function() {
        jQuery('.video_popup').remove();
    });

    jQuery(document).on('click', '.burger', function() {
        jQuery('header').toggleClass('open_menu');
        jQuery('.site_overlay').toggleClass('active');

        jQuery('.lazy_image').each(function() {
            jQuery(this).attr('src', jQuery(this).data('img_src'));
            jQuery(this).removeAttr('data-img_src');
        });
    });


    jQuery('.show_vid_play').each(function() {
        var youtubeId = jQuery(this).data('vid');
        if (youtubeId) {
            var iframe = jQuery('<iframe>', {
                src: 'https://www.youtube.com/embed/' + youtubeId + '?autoplay=1&mute=1&controls=0&showinfo=0&rel=0&start=30',
                frameborder: '0',
                width: '137%',
                height: '144%',
                allow: 'autoplay'
            });

            jQuery(this).find('.thumb').append(iframe);

            // Force the loop by checking current time
            setInterval(function() {
                // Get current time by adding src parameter
                iframe.attr('src', iframe.attr('src').split('&t=')[0] + '&t=' + 30);
            }, 15000); // Reset every 5 seconds
        }
    });


    const menuItems = jQuery('.top_menu .left ul li');
    const tabs = jQuery('.top_menu .right .tab');

    menuItems.not('.plain').hover(
        function() {
            menuItems.removeClass('active');
            jQuery(this).addClass('active');
            const tabRef = jQuery(this).data('tab_ref');
            tabs.removeClass('active');
            tabs.filter(`[data-tab="${tabRef}"]`).addClass('active');
        },
        function() {
        }
    );


    function updateLodgeVisibility() {
        // Get selected values for each filter type
        var selectedLocations = [];
        var selectedCameraTypes = [];

        jQuery('input[data-filter-type="location"]:checked').not('[data-filter-value="all"]').each(function() {
            selectedLocations.push(jQuery(this).data('filter-value'));
        });

        jQuery('input[data-filter-type="camera-type"]:checked').not('[data-filter-value="all"]').each(function() {
            selectedCameraTypes.push(jQuery(this).data('filter-value'));
        });

        var allLocationsSelected = jQuery('input[data-filter-type="location"][data-filter-value="all"]').prop('checked');
        var allCameraTypesSelected = jQuery('input[data-filter-type="camera-type"][data-filter-value="all"]').prop('checked');

        jQuery('.lodge_item').each(function() {
            var $lodge = jQuery(this);
            var lodgeLocations = $lodge.data('location').split(' ');
            var lodgeCameraTypes = $lodge.data('camera-type').split(' ');

            var locationMatch = allLocationsSelected || selectedLocations.some(loc => lodgeLocations.includes(loc));
            var cameraMatch = allCameraTypesSelected || selectedCameraTypes.some(cam => lodgeCameraTypes.includes(cam));

            if (locationMatch && cameraMatch) {
                $lodge.show();
            } else {
                $lodge.hide();
            }
        });
    }

    jQuery('input[data-filter-type="location"][data-filter-value="all"]').change(function() {
        var isChecked = jQuery(this).prop('checked');
        jQuery('input[data-filter-type="location"]').not(this).prop('checked', false);
        if (isChecked) {
            jQuery(this).prop('checked', true);
        }
        updateLodgeVisibility();
    });

    jQuery('input[data-filter-type="camera-type"][data-filter-value="all"]').change(function() {
        var isChecked = jQuery(this).prop('checked');
        jQuery('input[data-filter-type="camera-type"]').not(this).prop('checked', false);
        if (isChecked) {
            jQuery(this).prop('checked', true);
        }
        updateLodgeVisibility();
    });

    jQuery('input[data-filter-type="location"]').not('[data-filter-value="all"]').change(function() {
        var $allCheckbox = jQuery('input[data-filter-type="location"][data-filter-value="all"]');
        if (jQuery(this).prop('checked')) {
            $allCheckbox.prop('checked', false);
        } else if (!jQuery('input[data-filter-type="location"]:checked').not('[data-filter-value="all"]').length) {
            $allCheckbox.prop('checked', true);
        }
        updateLodgeVisibility();
    });

    jQuery('input[data-filter-type="camera-type"]').not('[data-filter-value="all"]').change(function() {
        var $allCheckbox = jQuery('input[data-filter-type="camera-type"][data-filter-value="all"]');
        if (jQuery(this).prop('checked')) {
            $allCheckbox.prop('checked', false);
        } else if (!jQuery('input[data-filter-type="camera-type"]:checked').not('[data-filter-value="all"]').length) {
            $allCheckbox.prop('checked', true);
        }
        updateLodgeVisibility();
    });

    jQuery('.blocks').on('click', function() {
        jQuery('.map').removeClass('active');
        jQuery(this).addClass('active');
        jQuery('.map_inner').hide();
        jQuery('.locations_inner').fadeIn();
    });


    jQuery('.map').on('click', function() {
        jQuery('.blocks').removeClass('active');
        jQuery(this).addClass('active');
        jQuery('.locations_inner').hide();
        jQuery('.map_inner').fadeIn();
    });

    jQuery('.frm_forms input, .frm_forms textarea').on('input change', function() {
        var field = jQuery(this);
        if(field.val().trim() !== '') {
            field.parent().addClass('field_has_value');
        } else {
            field.parent().removeClass('field_has_value');
        }
    });

    var faqs = document.querySelector('.faqs');

    if (faqs) {

        jQuery('.faq-answer').hide();

        jQuery('.faq-question').click(function() {
            var $this = jQuery(this);
            var answer = $this.next('.faq-answer');
            var plusIcon = $this.find('.plus-icon');
            var faqItem = $this.parent('.faq-item');


            jQuery('.faq-item').removeClass('active');

            answer.slideToggle(300, function() {

                if(answer.is(':visible')) {
                    faqItem.addClass('active');
                }
            });

            if (plusIcon.text() === '+') {
                plusIcon.text('-');
            } else {
                plusIcon.text('+');
            }

            var otherAnswers = jQuery('.faq-answer').not(answer);
            otherAnswers.slideUp(300);
            otherAnswers.parent('.faq-item').removeClass('active');
            jQuery('.plus-icon').not(plusIcon).text('+');
        });

    }

    var lodge_highlights = document.querySelector('.lodge_highlights');

    if(lodge_highlights) {
        let isLoading = false;
        const searchInput = jQuery('#search');
        const searchRef = jQuery('.search_ref');
        const highlightsContainer = jQuery('.lodge_highlights_inner');
        const originalSearchRef = searchRef.html();

        function debounce(func, wait) {
            let timeout;
            return function(...args) {
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(this, args), wait);
            };
        }

        searchInput.closest('form').on('submit', function(e) {
            e.preventDefault();
            const query = searchInput.val().toLowerCase();

            if (query.length < 2) {
                searchRef.hide();
                return;
            }

            let bestMatch = null;
            let bestMatchScore = 0;

            searchRef.find('li').each(function() {
                const name = jQuery(this).text().toLowerCase();
                if (name.includes(query)) {
                    const matchScore = query.length / name.length;
                    if (matchScore > bestMatchScore) {
                        bestMatchScore = matchScore;
                        bestMatch = {
                            id: jQuery(this).data('id'),
                            name: jQuery(this).text()
                        };
                    }
                }
            });

            if (bestMatch) {
                searchInput.val(bestMatch.name);
                searchRef.hide();
                fetchVideos(1, bestMatch.id, 'search');
            } else {
                highlightsContainer.html(`
                    <div class="no-results">
                        <h3>No videos found</h3>
                        <p>Try searching for a different animal</p>
                    </div>
                `);
            }
        });

        searchInput.on('input', debounce(function(e) {
            const query = jQuery(this).val().toLowerCase();

            if (query.length < 2) {
                searchRef.hide();
                return;
            }

            searchRef.html(originalSearchRef);

            const matches = [];
            searchRef.find('li').each(function() {
                const name = jQuery(this).data('name').toLowerCase();
                if (name.includes(query)) {
                    matches.push({
                        name: jQuery(this).data('name'),
                        id: jQuery(this).data('id')
                    });
                }
            });

            if (matches.length > 0) {
                let html = '<ul>';
                matches.forEach(match => {
                    html += `<li data-id="${match.id}">${match.name}</li>`;
                });
                html += '</ul>';

                searchRef.html(html).show();
            } else {
                searchRef.hide();
            }
        }, 300));

        searchRef.on('click', 'li', function() {
            const animalId = jQuery(this).data('id');
            const animalName = jQuery(this).text();

            searchInput.val(animalName);
            searchRef.hide();

            fetchVideos(1, animalId, 'search');
        });

        function fetchVideos(page, animalId = null, type) {
            isLoading = true;



            if(jQuery('#highlight_search').length > 0){
                type = 'not_lodge';
            }


            var target_lodge = jQuery('#target_lodge').text();
            var target_action = jQuery('#target_action').text();

            const filters = {
                youtube: 1
            };

            if (animalId) {
                filters.animal = parseInt(animalId);
            }

            const data = {
                action: 'get_africam_videos_new',
                page: page,
                lodge: target_lodge,
                filters: filters,
                searchtype: type
            };

            jQuery.ajax({
                url: my_ajax_object.ajax_url,
                type: 'POST',
                data: data,
                success: function(response) {
                    if (response.error) {
                        console.error('Error fetching videos:', response.message);
                        return;
                    }

                    const videos = response.data;
                    let html = '';

                    if ((!videos || videos.length === 0) && page === 1) {
                        html = `
                            <div class="no-results">
                                <h3>No videos found</h3>
                                <p>Try searching for a different animal</p>
                            </div>
                        `;
                        highlightsContainer.html(html);

                        highlightsContainer.find('.reset-search').on('click', function() {
                            searchInput.val('');
                            fetchVideos(1);
                        });

                        return;
                    }

                    if ((!videos || videos.length === 0) && page > 1) {
                        jQuery('.next_vid_fetch').remove();
                        isLoading = false;
                        return;
                    }

                    videos.forEach(video => {
                        const date = new Date(video.created_ts * 1000);
                        const formattedDate = date.toLocaleDateString('en-US', {
                            month: 'short',
                            day: 'numeric',
                            year: 'numeric'
                        });

                        html += `
                            <div class="video_block play_vid_pop" data-vid="${video.youtube_id}">
                                <img src="${video.cover}" alt="${video.title}"/>
                                <div class="date">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
                                        <path d="M12.9556 6.21735V4.39317C12.9556 3.72153 12.4112 3.17706 11.7395 3.17706H4.44282C3.77117 3.17706 3.2267 3.72153 3.2267 4.39317V6.21735M12.9556 6.21735V11.6899C12.9556 12.3615 12.4112 12.906 11.7395 12.906H4.44282C3.77117 12.906 3.2267 12.3615 3.2267 11.6899V6.21735M12.9556 6.21735H3.2267M5.65894 1.96094V4.39317M10.5234 1.96094V4.39317" stroke="#A8A8A8" stroke-width="1.43073" stroke-linecap="round"/>
                                        <path d="M5.96169 7.4375H4.74557C4.57766 7.4375 4.44154 7.57362 4.44154 7.74153V8.95765C4.44154 9.12556 4.57766 9.26168 4.74557 9.26168H5.96169C6.1296 9.26168 6.26572 9.12556 6.26572 8.95765V7.74153C6.26572 7.57362 6.1296 7.4375 5.96169 7.4375Z" fill="#A8A8A8"/>
                                        <path d="M8.69802 7.4375H7.4819C7.31399 7.4375 7.17787 7.57362 7.17787 7.74153V8.95765C7.17787 9.12556 7.31399 9.26168 7.4819 9.26168H8.69802C8.86593 9.26168 9.00205 9.12556 9.00205 8.95765V7.74153C9.00205 7.57362 8.86593 7.4375 8.69802 7.4375Z" fill="#A8A8A8"/>
                                        <path d="M11.4324 7.4375H10.2163C10.0484 7.4375 9.91225 7.57362 9.91225 7.74153V8.95765C9.91225 9.12556 10.0484 9.26168 10.2163 9.26168H11.4324C11.6003 9.26168 11.7364 9.12556 11.7364 8.95765V7.74153C11.7364 7.57362 11.6003 7.4375 11.4324 7.4375Z" fill="#A8A8A8"/>
                                    </svg>
                                    ${formattedDate}
                                </div>
                                <h3>${video.title}</h3>
                            </div>
                        `;
                    });

                    const tempContainer = jQuery('<div>').html(html);

                    if (!tempContainer.find('.next_vid_fetch').length && videos && videos.length > 0) {
                        tempContainer.append('<div class="next_vid_fetch" data-page="' + (page + 1) + '"></div>');
                    }

                    if (page === 1) {
                        highlightsContainer.html(tempContainer.html());
                    } else {
                        highlightsContainer.find('.next_vid_fetch').remove();
                        highlightsContainer.append(tempContainer.html());
                    }

                    isLoading = false;

                    if(response.meta.pagination.total_pages === response.meta.pagination.current_page) {
                        jQuery('.next_vid_fetch').remove();
                        isLoading = false;
                        return;
                    }
                },
                error: function(xhr, status, error) {
                    console.error('Ajax error:', error);
                    isLoading = false;
                }
            });
        }

        jQuery(window).on('scroll', debounce(function() {
            if (isLoading) return;

            const nextFetch = jQuery('.next_vid_fetch');
            if (nextFetch.length === 0) return;

            const scrollPosition = jQuery(window).scrollTop() + jQuery(window).height();
            const triggerPosition = nextFetch.offset().top - 200;

            if (scrollPosition > triggerPosition) {
                const nextPage = nextFetch.data('page');
                const currentAnimalId = searchInput.val() ?
                    searchRef.find('li:contains("' + searchInput.val() + '")').data('id') :
                    null;

                fetchVideos(nextPage, currentAnimalId, 'loadmore');
            }
        }, 200));
    }

});

